import React from 'react'
import { useState } from 'react'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeNumberBasForm from './ChangeNumberBasForm'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit';

const ChangeNumberBasButton = ({ writeOffAct }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={writeOffAct.numberBas}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
            positionIco='left'
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування номеру акту з БАС'}
            disableClickOutside={true}
            content={
                <ChangeNumberBasForm
                    writeOffActBd={writeOffAct}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeNumberBasButton